import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-case-analytics-item',
    templateUrl: './case-analytics-item.component.html',
    styleUrls: ['./case-analytics-item.component.scss'],
    standalone: false
})

export class CaseAnalyticsItemComponent extends BaseComponent implements OnInit {
  @Input() noDataInCase: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public hasNoData = false;
  constructor() {
    super();
  }

  ngOnInit() {
    this.noDataInCase.pipe(
      filter((value): value is false => !!value),
    ).subscribe((noDataInCase => {
      this.hasNoData = noDataInCase;
    }));
  }
}
